"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6675],{

/***/ 96675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(52029);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23978);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(62135);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(29620);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77745);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(95398);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(44642);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(22841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(75158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(76779);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(54225);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29630);
/* harmony import */ var _src_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53249);
/* harmony import */ var _src_api_match__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91088);
/* harmony import */ var _src_hook_useUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92859);
/* harmony import */ var _src_ruix__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9869);
/* harmony import */ var _src_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51413);
/* harmony import */ var _src_utils_budget__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65122);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88767);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4480);
/* harmony import */ var _apply_ApplyContent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19025);
/* harmony import */ var _base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66660);
/* harmony import */ var _profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22240);
/* harmony import */ var _SignComponent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34489);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	background-color: var(--bg-white);\n	padding: 4px;\n\n	display: flex;\n	flex-direction: row;\n	align-items: center;\n	justify-content: space-around;\n	flex-wrap: wrap;\n\n	@media screen and (max-width: 768px) {\n		flex-direction: column;\n		align-items: start;\n		justify-content: start;\n	}\n	div {\n		font-size: 18px;\n		font-weight: 600;\n		line-height: 30px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 15px;\n\n	@media screen and (max-width: 768px) {\n		height: auto;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















// 전문가가 받을 수 있는 금액 계산 함수
var calculateExpertPrice = function(expectedPrice) {
    // "2,000만원" 같은 패턴에서 금액 부분만(콤마 포함) 추출
    var m = expectedPrice.match(/([\d,]+)\s*만원/);
    if (!m) return expectedPrice;
    var priceInManwon = Number(m[1].replace(/,/g, "")); // "2,000" -> 2000
    var expertPrice = Math.ceil(priceInManwon * 0.75);
    return "".concat(expertPrice.toLocaleString(), "만원");
};
// 빈 값을 표시하는 함수
var getDisplayText = function(value) {
    var defaultText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var hasValue = value && value.trim() !== "";
    return hasValue ? value : defaultText;
};
var OpenWorkRequest = function(props) {
    // const { list } = props;
    var matchUuid = props.matchUuid, job = props.job, endTime = props.endTime, client = props.client, time = props.time, expectedPrice = props.expectedPrice, clientBudget = props.clientBudget, comment = props.comment, neededSkills = props.neededSkills, workType = props.workType, workPurpose = props.workPurpose, workDetail = props.workDetail, brandName = props.brandName, brandUrl = props.brandUrl, businessType = props.businessType, type = props.type, isMe = props.isMe, remoteWork = props.remoteWork;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useQueryClient)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), openAcceptD = ref[0], setOpenAcceptD = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), openAcceptDescD = ref1[0], setOpenAcceptDescD = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), openFeeInfoD = ref2[0], setOpenFeeInfoD = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""), commentMessage = ref3[0], setCommentMessage = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)([]), questionAnswers = ref4[0], setQuestionAnswers = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(true), isInitialLoad = ref5[0], setIsInitialLoad = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false), isAgree = ref6[0], setIsAgree = ref6[1];
    var user = (0,_src_hook_useUser__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().user;
    var ref7 = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useQuery)("getExpertsDirectStatus", _src_api__WEBPACK_IMPORTED_MODULE_3__/* .getExpertsDirectStatus */ .Je, {
        enabled: user.isLogin && user.userType === 2
    }), expertStatus = ref7.data, refetch = ref7.refetch;
    var setSnackbareState = (0,recoil__WEBPACK_IMPORTED_MODULE_10__/* .useSetRecoilState */ .Zl)(_src_state__WEBPACK_IMPORTED_MODULE_7__/* .globalSnackbarState */ .j8);
    var ref8 = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useMutation)(_src_api_match__WEBPACK_IMPORTED_MODULE_4__.applyOpenMatch, {
        onSuccess: function() {
            setOpenAcceptD(true);
            setOpenAcceptDescD(false);
            queryClient.refetchQueries([
                "getMatchs"
            ]);
            queryClient.refetchQueries([
                "getMatchList"
            ]);
        },
        onError: function() {
            setSnackbareState("죄송합니다. 채널톡으로 문의 부탁 드립니다.");
        }
    }), mutate = ref8.mutate, isLoading = ref8.isLoading, isError = ref8.isError;
    // 임시저장 mutation
    var ref9 = (0,react_query__WEBPACK_IMPORTED_MODULE_9__.useMutation)(_src_api_match__WEBPACK_IMPORTED_MODULE_4__.saveQuestionAnswersDraft, {
        onError: function() {
        // 임시저장 실패는 조용히 처리 (사용자에게 알리지 않음)
        }
    }), saveDraftMutate = ref9.mutate;
    var expertPrice = calculateExpertPrice(expectedPrice);
    // 주 활용 시간 표시 텍스트 계산 (순수 숫자만 "주 X시간" 형식, 한글/영문 포함 시 원본 그대로)
    var rawTime = (time || "").trim();
    var timeDisplayText = rawTime === "" || rawTime === "0" ? "추후협의" : /^\d+$/.test(rawTime) ? "주 ".concat(rawTime, "시간") : rawTime;
    // 질문이 있는 경우 초기화 및 DB에서 저장된 답변 불러오기
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (props.expertQuestions && Array.isArray(props.expertQuestions) && props.expertQuestions.length > 0) {
            setIsInitialLoad(true);
            // DB에서 저장된 답변 불러오기
            var savedAnswers = props.savedQuestionAnswers;
            if (Array.isArray(savedAnswers) && savedAnswers.length > 0) {
                // 질문이 변경되었을 수 있으므로 현재 질문과 매칭
                var matchedAnswers = props.expertQuestions.map(function(question) {
                    var saved = savedAnswers.find(function(a) {
                        return a && a.question === question;
                    });
                    return {
                        question: question,
                        answer: saved && typeof saved.answer === "string" ? saved.answer : ""
                    };
                });
                setQuestionAnswers(matchedAnswers);
            } else {
                setQuestionAnswers(props.expertQuestions.map(function(question) {
                    return {
                        question: question,
                        answer: ""
                    };
                }));
            }
            // 초기 로드 완료 후 약간의 지연을 두고 isInitialLoad를 false로 설정
            setTimeout(function() {
                setIsInitialLoad(false);
            }, 500);
        }
    }, [
        props.expertQuestions,
        props.savedQuestionAnswers
    ]);
    // 답변 변경 시 debounce로 DB에 임시저장
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        // 초기 로드 중이거나 질문이 없으면 저장하지 않음
        if (isInitialLoad || questionAnswers.length === 0 || !props.expertQuestions || props.expertQuestions.length === 0) {
            return;
        }
        // 이미 지원한 경우(expertComment가 있으면 이미 지원한 것으로 간주) 임시저장하지 않음
        if (props.expertComment) {
            return;
        }
        // debounce: 1초 후 저장
        var timeoutId = setTimeout(function() {
            // 모든 답변이 비어있지 않은 경우에만 저장
            var hasAnyAnswer = questionAnswers.some(function(qa) {
                return qa.answer && qa.answer.trim().length > 0;
            });
            if (hasAnyAnswer) {
                saveDraftMutate({
                    matchUuid: matchUuid,
                    questionAnswers: questionAnswers
                });
            }
        }, 1000);
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        questionAnswers,
        matchUuid,
        props.expertQuestions,
        isInitialLoad,
        saveDraftMutate,
        props.expertComment
    ]);
    // 조건부 렌더링을 위한 변수들
    var hasQuestions = Array.isArray(props.expertQuestions) && props.expertQuestions.length > 0;
    var hasSubmittedAnswers = Array.isArray(props.questionAnswers) && props.questionAnswers.length > 0;
    var hasExpertComment = !!props.expertComment;
    var shouldShowReadOnlyAnswers = hasQuestions && user.userType === 2 && hasSubmittedAnswers && hasExpertComment;
    var canWriteAnswers = hasQuestions && user.userType === 2 && type === 2 && !isMe && !hasExpertComment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_apply_ApplyContent__WEBPACK_IMPORTED_MODULE_11__/* .Wrapper */ .im, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .WrapperContainer */ .t4, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        fontSize: "32px",
                        fontWeight: "bold",
                        color: "var(--primary)"
                    },
                    children: client
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        fontSize: "24px",
                        fontWeight: 500,
                        color: "var(--card-bg)"
                    },
                    children: job
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                    style: {
                        paddingLeft: "5px"
                    },
                    order: "row-center-start",
                    gap: 30,
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: "매칭 조건"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                            style: {
                                width: "auto",
                                flex: "1"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(remoteWork),
                    notChip: true,
                    title: "비대면 가능 여부"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: timeDisplayText,
                    notChip: true,
                    title: "주 활용 시간"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: clientBudget === 0 || expectedPrice === "0" ? "추후협의" : clientBudget == null ? undefined : expectedPrice,
                    notChip: true,
                    title: user.userType === 2 ? "월 인건비 예산" : "월 인건비 예산\n(VAT 별도)"
                }),
                props.monthlyAdBudget !== null && props.monthlyAdBudget !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: "".concat((0,_src_utils_budget__WEBPACK_IMPORTED_MODULE_15__/* .formatKrwAsManwonInput */ .RX)(props.monthlyAdBudget), "만원"),
                    notChip: true,
                    title: "월 평균 광고비 예산"
                }),
                typeof props.canProduceCreativeInternally === "string" && props.canProduceCreativeInternally.trim() !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: props.canProduceCreativeInternally === "yes" ? "예" : props.canProduceCreativeInternally === "no" ? "아니오" : "미해당/미정",
                    notChip: true,
                    title: "내부 소재 제작 가능 여부"
                }),
                user.userType === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: expertPrice,
                    invisibleOption: true,
                    notChip: true,
                    title: "전문가 대금"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                    style: {
                        paddingLeft: "5px"
                    },
                    order: "row-center-start",
                    gap: 30,
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: "기업 정보"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                            style: {
                                width: "auto",
                                flex: "1"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(brandName),
                    notChip: true,
                    title: "브랜드/서비스"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(brandUrl),
                    notChip: true,
                    link: true,
                    title: "홈페이지"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(businessType),
                    notChip: true,
                    title: "비즈니스 유형"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                    style: {
                        paddingLeft: "5px"
                    },
                    order: "row-center-start",
                    gap: 30,
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: "업무"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                            style: {
                                width: "auto",
                                flex: "1"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 15
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(workPurpose),
                    notChip: true,
                    title: "업무 목표"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(props.currentSituation),
                    notChip: true,
                    title: "현재 상황",
                    topAlign: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(props.expectedWorkload),
                    notChip: true,
                    title: "업무 범위",
                    topAlign: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(neededSkills),
                    notChip: true,
                    title: "필수 역량"
                }),
                user.userType !== 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    style: {
                        marginLeft: "5px",
                        marginTop: "4px",
                        marginBottom: "12px",
                        color: "#000",
                        fontSize: "13px",
                        lineHeight: 1.6
                    },
                    children: [
                        "필수 역량 조건이 너무 많을 경우, 추천 가능한 전문가의 범위가 과도하게 줄어듭니다. ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                            style: {
                                color: "#1976d2"
                            },
                            children: "매칭 정확성 극대화"
                        }),
                        "를 위해, ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                            style: {
                                color: "#1976d2"
                            },
                            children: "반드시 지켜져야 하는 조건 외에는"
                        }),
                        " 우대 역량에 작성하는 것을 권장드립니다."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(props.preferredSkills),
                    notChip: true,
                    title: "우대 역량"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(props.internalCollaborators),
                    notChip: true,
                    title: "내부 협업 가능 인력"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_profile_components_ProfileListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    dark: true,
                    text: getDisplayText(comment),
                    notChip: true,
                    title: "기타 고려사항",
                    topAlign: true
                }),
                user.userType === 1 && props.expertQuestions && Array.isArray(props.expertQuestions) && props.expertQuestions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 30
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                            style: {
                                paddingLeft: "5px"
                            },
                            order: "row-center-start",
                            gap: 30,
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "20px",
                                        fontWeight: "500"
                                    },
                                    children: "전문가 지원 질문"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                                    style: {
                                        width: "auto",
                                        flex: "1"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 15
                        }),
                        props.expertQuestions.map(function(question, index) {
                            if (!question || typeof question !== "string") return null;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    marginBottom: "20px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        style: {
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            color: "#2c3e50",
                                            marginBottom: "8px"
                                        },
                                        children: [
                                            "질문 ",
                                            index + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            backgroundColor: "#f5f5f5",
                                            padding: "16px",
                                            borderRadius: "8px",
                                            border: "1px solid #e0e0e0",
                                            fontSize: "15px",
                                            color: "#424242",
                                            lineHeight: 1.6,
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)"
                                        },
                                        children: question
                                    })
                                ]
                            }, index);
                        })
                    ]
                }),
                shouldShowReadOnlyAnswers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 30
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                            style: {
                                paddingLeft: "5px"
                            },
                            order: "row-center-start",
                            gap: 30,
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "20px",
                                        fontWeight: "500"
                                    },
                                    children: "지원 문답"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                                    style: {
                                        width: "auto",
                                        flex: "1"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 15
                        }),
                        (props.questionAnswers || []).map(function(qa, index) {
                            var ref;
                            if (!qa || typeof qa !== "object") return null;
                            var questionText = qa.question && typeof qa.question === "string" ? qa.question : ((ref = props.expertQuestions) === null || ref === void 0 ? void 0 : ref[index]) && typeof props.expertQuestions[index] === "string" ? props.expertQuestions[index] : "질문 ".concat(index + 1);
                            var answerText = qa.answer && typeof qa.answer === "string" ? qa.answer : "";
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    marginBottom: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        style: {
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            color: "#2c3e50",
                                            marginBottom: "12px"
                                        },
                                        children: [
                                            "질문 ",
                                            index + 1,
                                            ": ",
                                            questionText
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            backgroundColor: "#fafafa",
                                            padding: "20px",
                                            borderRadius: "12px",
                                            border: "1px solid #e8e8e8",
                                            whiteSpace: "pre-wrap",
                                            lineHeight: "1.7",
                                            fontSize: "15px",
                                            color: "#2c2c2c",
                                            fontWeight: "400",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)"
                                        },
                                        children: answerText
                                    })
                                ]
                            }, index);
                        })
                    ]
                }),
                canWriteAnswers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 30
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                            style: {
                                paddingLeft: "5px"
                            },
                            order: "row-center-start",
                            gap: 30,
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "20px",
                                        fontWeight: "500"
                                    },
                                    children: "지원 문답 작성"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                                    style: {
                                        width: "auto",
                                        flex: "1"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 15
                        }),
                        Array.isArray(questionAnswers) && questionAnswers.map(function(qa, index) {
                            if (!qa || typeof qa !== "object" || typeof qa.question !== "string") {
                                return null;
                            }
                            var answerValue = qa.answer && typeof qa.answer === "string" ? qa.answer : "";
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                style: {
                                    marginBottom: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        style: {
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            color: "#2c3e50",
                                            marginBottom: "12px"
                                        },
                                        children: [
                                            "질문 ",
                                            index + 1,
                                            ": ",
                                            qa.question
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        fullWidth: true,
                                        multiline: true,
                                        minRows: 4,
                                        maxRows: 8,
                                        placeholder: "질문에 대한 답변을 작성해주세요. (최대 300자)",
                                        value: answerValue,
                                        onChange: function(e) {
                                            var value = e.target.value;
                                            // 300자 제한
                                            if (value.length <= 300) {
                                                var newAnswers = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(questionAnswers);
                                                if (newAnswers[index]) {
                                                    newAnswers[index] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, newAnswers[index]), {
                                                        answer: value
                                                    });
                                                    setQuestionAnswers(newAnswers);
                                                }
                                            }
                                        },
                                        inputProps: {
                                            maxLength: 300
                                        },
                                        helperText: "".concat(answerValue.length, "/300자"),
                                        sx: {
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "#fafafa"
                                            }
                                        }
                                    })
                                ]
                            }, index);
                        })
                    ]
                }),
                user.userType === 2 && props.expertComment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        style: {
                            marginBottom: "24px",
                            paddingBottom: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                                space: 30
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                                style: {
                                    paddingLeft: "5px"
                                },
                                order: "row-center-start",
                                gap: 30,
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        style: {
                                            fontSize: "20px",
                                            fontWeight: "500",
                                            marginBottom: "20px"
                                        },
                                        children: "지원 코멘트"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                                        style: {
                                            width: "auto",
                                            flex: "1"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                style: {
                                    backgroundColor: "#fafafa",
                                    padding: "20px",
                                    borderRadius: "12px",
                                    border: "1px solid #e8e8e8",
                                    whiteSpace: "pre-wrap",
                                    lineHeight: "1.7",
                                    fontSize: "15px",
                                    color: "#2c2c2c",
                                    fontWeight: "400",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
                                    marginTop: "10px"
                                },
                                children: props.expertComment
                            })
                        ]
                    })
                }),
                type === 2 && !isMe && user.userType === 2 && !props.expertComment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 30
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_src_ruix__WEBPACK_IMPORTED_MODULE_6__/* .GroupA */ .so, {
                            style: {
                                paddingLeft: "5px"
                            },
                            order: "row-center-start",
                            gap: 30,
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        fontSize: "20px",
                                        fontWeight: "500"
                                    },
                                    children: "지원 코멘트"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_base_BasicFormWrapper__WEBPACK_IMPORTED_MODULE_12__/* .LightLine */ .vo, {
                                    style: {
                                        width: "auto",
                                        flex: "1"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 15
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            fullWidth: true,
                            multiline: true,
                            minRows: 5,
                            maxRows: 10,
                            placeholder: "의사 결정에 참고할 수 있도록 요청 업무와 관련된 경험을 적어주시면 프로필 수락 확률이 높아집니다",
                            value: commentMessage,
                            onChange: function(e) {
                                return setCommentMessage(e.target.value);
                            },
                            sx: {
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#fafafa"
                                }
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                                space: 30
                            }),
                            type === 2 && !isMe && !props.expertComment ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    sx: {
                                        ".MuiLoadingButton-loadingIndicator": {
                                            color: "white"
                                        }
                                    },
                                    className: "btn",
                                    fullWidth: true,
                                    loading: isLoading,
                                    variant: "contained",
                                    onClick: function() {
                                        // 모달 열기 전에 검증
                                        // 1. 지원 코멘트 검증
                                        if (commentMessage.trim().length <= 0) {
                                            setSnackbareState("지원 코멘트를 작성해주세요.");
                                            return;
                                        }
                                        // 2. 질문이 있는 경우 모든 답변이 작성되었는지 확인
                                        if (Array.isArray(props.expertQuestions) && props.expertQuestions.length > 0) {
                                            // 질문 개수와 답변 개수가 일치하는지 확인
                                            if (!Array.isArray(questionAnswers) || questionAnswers.length !== props.expertQuestions.length) {
                                                setSnackbareState("모든 질문에 답변을 작성해주세요.");
                                                return;
                                            }
                                            // 모든 답변이 비어있지 않은지 확인
                                            var hasEmptyAnswer = questionAnswers.some(function(qa) {
                                                return !qa || typeof qa !== "object" || !qa.answer || typeof qa.answer !== "string" || qa.answer.trim().length === 0;
                                            });
                                            if (hasEmptyAnswer) {
                                                setSnackbareState("모든 질문에 답변을 작성해주세요.");
                                                return;
                                            }
                                        }
                                        // 검증 통과 시 모달 열기
                                        setOpenAcceptDescD(true);
                                    },
                                    children: "지원하기"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    open: openAcceptDescD,
                    onClose: function() {
                        setOpenAcceptDescD(false);
                    },
                    sx: {
                        ".MuiDialog-paper": {
                            backgroundColor: "var(--bg-white)",
                            color: "var(--card-bg)",
                            fontWeight: "bold",
                            borderRadius: "18px",
                            paddingBottom: "10px"
                        }
                    },
                    fullWidth: true,
                    maxWidth: "sm",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: "var(--primary)",
                                color: "#fff",
                                fontWeight: "bold"
                            },
                            children: "지원하기 전 확인사항"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 10
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                sx: {
                                    color: "var(--card-bg)",
                                    fontSize: "14px",
                                    lineHeight: 1.6
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        sx: {
                                            mb: 2,
                                            fontSize: "14px"
                                        },
                                        children: "프로필의 업무 적합도 및 내부 기준에 따라 일부 지원 전문가에게 원포인트 추천 뱃지가 부여됩니다."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        sx: {
                                            mb: 3,
                                            fontSize: "14px"
                                        },
                                        children: "안전한 거래를 위해 플랫폼 외 소통 및 고객사와의 직접 거래는 금지되어 있으며, 위반 시 원포인트 서비스 계약서 제6조 7항에 따라 활동 제한 또는 손해배상의 책임이 발생할 수 있습니다."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                setIsAgree(!isAgree);
                                            },
                                            checked: isAgree
                                        }),
                                        label: "위 내용을 확인하였으며, 원포인트 내에서의 안전한 거래에 동의합니다.",
                                        sx: {
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "14px"
                                            }
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                    onClick: function() {
                                        setOpenAcceptDescD(false);
                                    },
                                    children: "취소"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    sx: {
                                        ".MuiLoadingButton-loadingIndicator": {
                                            color: "var(--card-bg)"
                                        }
                                    },
                                    variant: "contained",
                                    loading: isLoading,
                                    onClick: function() {
                                        if (!isAgree) {
                                            setSnackbareState("위 내용에 동의해주세요.");
                                            return;
                                        }
                                        // 모달에서는 동의 확인만 하고 바로 지원 진행 (검증은 이미 모달 열기 전에 완료됨)
                                        mutate({
                                            matchUuid: matchUuid,
                                            comment: commentMessage,
                                            questionAnswers: Array.isArray(props.expertQuestions) && props.expertQuestions.length > 0 && Array.isArray(questionAnswers) ? questionAnswers : undefined
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                        sx: {
                                            fontWeight: "bold"
                                        },
                                        children: "지원하기"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    open: openAcceptD,
                    onClose: function() {
                        setOpenAcceptD(false);
                    },
                    sx: {
                        ".MuiDialog-paper": {
                            backgroundColor: "white",
                            color: "var(--card-bg)",
                            fontWeight: "bold",
                            borderRadius: "18px",
                            paddingBottom: "10px"
                        }
                    },
                    maxWidth: "xs",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: "var(--primary)",
                                color: "#fff",
                                fontWeight: "bold"
                            },
                            children: "인터뷰 지원이 완료되었습니다"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 10
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                sx: {
                                    color: "var(--card-bg)"
                                },
                                children: "고객사 측에 전문가님 프로필을 전달 예정입니다.\n고객사 의사 결정에 도움이 되도록 프로필 보완이\n필요하다면 수정 부탁드립니다."
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                variant: "contained",
                                onClick: function() {
                                    //
                                    setOpenAcceptD(false);
                                    setCommentMessage("");
                                    window.open("https://docs.channel.io/onepoint/ko/articles/%EA%B3%A0%EA%B0%9D%EC%82%AC-%EB%A7%A4%EC%B9%AD-%ED%94%84%EB%A1%9C%EC%84%B8%EC%8A%A4-4337bd80");
                                },
                                autoFocus: true,
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                    sx: {
                                        fontWeight: "bold"
                                    },
                                    children: "확인"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                            space: 20
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 30
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "risk-free-text",
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "4px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: "원포인트의 모든 계약은 Risk-Free 프로그램이 적용됩니다."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: "(프로젝트 유형 제외)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            href: "https://docs.channel.io/onepoint/ko/articles/%EB%A6%AC%EC%8A%A4%ED%81%AC-%ED%94%84%EB%A6%AC-%EC%A0%95%EC%B1%85-%EC%95%88%EB%82%B4-1286c10a",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: {
                                color: "var(--primary)",
                                textDecoration: "none",
                                fontWeight: "600",
                                whiteSpace: "nowrap"
                            },
                            children: "[자세히 보기]"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SignComponent__WEBPACK_IMPORTED_MODULE_14__/* .EmptySpace */ .zV, {
                    space: 50
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    open: openFeeInfoD,
                    onClose: function() {
                        setOpenFeeInfoD(false);
                    },
                    sx: {
                        ".MuiDialog-paper": {
                            backgroundColor: "var(--bg-white)",
                            color: "var(--card-bg)",
                            borderRadius: "16px",
                            paddingBottom: "10px",
                            minWidth: "300px"
                        }
                    },
                    maxWidth: "sm",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: "var(--primary)",
                                color: "#fff",
                                fontWeight: "bold",
                                textAlign: "center",
                                padding: "12px 16px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: "원포인트 제공 서비스"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            sx: {
                                padding: "20px",
                                paddingBottom: "12px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                style: {
                                    marginBottom: "0px",
                                    marginTop: "12px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                    style: {
                                        fontSize: "13px",
                                        lineHeight: "1.4",
                                        margin: "0 auto",
                                        padding: "0",
                                        listStyle: "none",
                                        width: "fit-content"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            style: {
                                                marginBottom: "6px",
                                                textAlign: "left"
                                            },
                                            children: "• 업무 기회를 지속적으로 제공합니다"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            style: {
                                                marginBottom: "6px",
                                                textAlign: "left"
                                            },
                                            children: "• 고객 대금 미지급 리스크를 대신 부담합니다"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            style: {
                                                marginBottom: "6px",
                                                textAlign: "left"
                                            },
                                            children: "• 결제 정산 등 번거로운 업무를 대행합니다"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            style: {
                                                marginBottom: "6px",
                                                textAlign: "left"
                                            },
                                            children: "• 분쟁 발생시 중재를 도와드립니다"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            sx: {
                                padding: "0 20px 16px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                                variant: "contained",
                                onClick: function() {
                                    setOpenFeeInfoD(false);
                                },
                                autoFocus: true,
                                fullWidth: true,
                                sx: {
                                    borderRadius: "8px"
                                },
                                children: "확인"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OpenWorkRequest);
var TopDataBox = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var TopDataEmpty = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());


/***/ }),

/***/ 65122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ convertManwonInputToKrw; },
/* harmony export */   "RX": function() { return /* binding */ formatKrwAsManwonInput; },
/* harmony export */   "hH": function() { return /* binding */ MAX_MONTHLY_AD_BUDGET_MANWON; },
/* harmony export */   "uA": function() { return /* binding */ MAX_MONTHLY_AD_BUDGET_KRW; }
/* harmony export */ });
var MAX_MONTHLY_AD_BUDGET_MANWON = 200000;
var MAX_MONTHLY_AD_BUDGET_KRW = 2000000000;
var formatKrwAsManwonInput = function(value) {
    if (value === null || value === undefined || value === "") return "";
    var numericValue = String(value).replace(/[^\d]/g, "");
    if (numericValue === "") return "";
    var krw = Number(numericValue);
    if (!Number.isFinite(krw) || krw === 0) return "0";
    return Math.round(krw / 10000).toLocaleString();
};
var convertManwonInputToKrw = function(value) {
    var numericValue = String(value || "").replace(/[^\d,]/g, "");
    var numberOnly = numericValue.replace(/,/g, "");
    if (numberOnly === "") return "";
    if (/^0+$/.test(numberOnly)) return "0";
    var manwon = Number(numberOnly);
    if (!Number.isFinite(manwon)) return "";
    return (manwon * 10000).toLocaleString();
};


/***/ })

}]);